import { Link } from "react-router-dom";
import type { Manga } from "@/mocks/manga";
import { getCategory } from "@/utils/manga";

export default function MangaCard({ manga }: { manga: Manga }) {
  const cat = getCategory(manga.category);
  return (
    <Link
      to={`/manga/${manga.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200 hover:shadow-sm"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-200">
        <img
          src={manga.cover}
          alt={`${manga.title} 漫画封面`}
          loading="lazy"
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute left-2 top-2 flex gap-1">
          {manga.isFree && (
            <span className="rounded-md bg-primary-500 px-1.5 py-0.5 text-xs font-medium text-background-50">
              免费
            </span>
          )}
          {manga.isNew && (
            <span className="rounded-md bg-accent-500 px-1.5 py-0.5 text-xs font-medium text-background-50">
              新作
            </span>
          )}
        </div>
        {manga.status === "已完结" && (
          <span className="absolute bottom-2 right-2 rounded-md bg-foreground-950/75 px-1.5 py-0.5 text-xs text-background-50">
            已完结
          </span>
        )}
        <div className="absolute inset-x-0 bottom-0 flex items-center justify-between bg-gradient-to-t from-foreground-950/70 to-transparent px-2 pb-2 pt-6">
          <span className="text-xs font-medium text-background-50">{cat.name}</span>
          <span className="flex items-center gap-0.5 text-xs font-medium text-secondary-200">
            <i className="ri-star-fill text-secondary-300" />
            {manga.rating.toFixed(1)}
          </span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="truncate text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-700">
          {manga.title}
        </h3>
        <p className="mt-1 truncate text-xs text-foreground-500">{manga.updateInfo}</p>
      </div>
    </Link>
  );
}